<template>
  <div class="background" :style="this.$route.name === 'home'? 'min-height: 100vh !important' : '', this.$route.name === 'register'? 'min-height: calc(100% + 80px)' : ''">
    <img class="bg_img" src="../../public/assets/environment.png" alt="">
    <img class="bg_img" src="../../public/assets/environment.png" alt="">
    <div></div>
    <!-- <div class="endless_bg"></div><div class="endless_bg"></div> -->


    <img class="bg_item bg_hardhat" src="../../public/assets/items/hardhat.svg" alt="">


    <img class="bg_item bg_glove" src="../../public/assets/items/glove.svg" alt="">
    <img class="bg_item bg_glove_2" src="../../public/assets/items/gloves.svg" alt="">

    <img class="bg_item bg_earphones" src="../../public/assets/items/earphones.svg" alt="">
    <img class="bg_item bg_glasses" src="../../public/assets/items/fleece.svg" alt=""><img class="bg_item bg_boot_2"
      src="../../public/assets/items/hivis.svg" alt="">
    <img class="bg_ipad" src="../../public/assets/fitbit.png" alt="">
  </div>
</template>
<script>
  import TWEEN from '@/plugins/Tween.js'

  export default {
    name: 'AppIpadBackground',
    methods: {
      animateBackground: function () {

        function updateSizes() {
          width = document.querySelector('.bg_img').offsetWidth;
        }

        window.onresize = updateSizes;
        var t = 0;
        var img_0 = 0;
        var img_1 = 0;
        var width = 0;
        setTimeout(function () {
          width = document.querySelector('.bg_img').offsetWidth;
          // console.log(width);
        }, 300)

        function update(progress) {
          if (t > -1 * width) {
            t -= 1;
          } else {
            t = 0;
          }
          img_0 = t;
          img_1 = width + t;
        }

        function draw() {
          // console.log(t);
          document.querySelectorAll('.bg_img')[0].style.right = img_0 + 'px';
          document.querySelectorAll('.bg_img')[1].style.right = img_1 + 'px';

          // console.log('up');
          // Draw the state of the world
        }

        function loop(timestamp) {
          var progress = timestamp - lastRender

          update(progress)
          draw()

          lastRender = timestamp
          window.requestAnimationFrame(loop)
        }
        var lastRender = 0
        window.requestAnimationFrame(loop)
      }
    },
    mounted() {
      this.animateBackground();
    }
  }
</script>

<style>
  @keyframes hardhat_1 {
    0% {
      transform: translateY(0px) rotateZ(10deg);
    }

    25% {
      transform: translateY(10px) rotateZ(10deg);

    }

    50% {
      transform: translateY(0px) rotateZ(10deg);

    }

    75% {
      transform: translateY(-10px) rotateZ(10deg);

    }

    100% {
      transform: translateY(0px) rotateZ(10deg);

    }
  }

  @keyframes hover {
    0% {
      transform: translateY(0px) rotateZ(0deg);
    }

    25% {
      transform: translateY(10px) rotateZ(0deg);

    }

    50% {
      transform: translateY(0px) rotateZ(0deg);

    }

    75% {
      transform: translateY(-10px) rotateZ(0deg);

    }

    100% {
      transform: translateY(0px) rotateZ(0deg);

    }
  }

  @keyframes earphones_1 {
    0% {
      transform: translateY(15px) rotateZ(10deg);
    }

    25% {
      transform: translateY(-5px) rotateZ(10deg);

    }

    50% {
      transform: translateY(0px) rotateZ(10deg);

    }

    75% {
      transform: translateY(5px) rotateZ(10deg);

    }

    100% {
      transform: translateY(15px) rotateZ(10deg);

    }
  }

  @keyframes boot_1 {
    0% {
      transform: translateY(-5px) rotateY(180deg);
    }

    25% {
      transform: translateY(10px) rotateY(180deg);

    }

    50% {
      transform: translateY(5px) rotateY(180deg);

    }

    75% {
      transform: translateY(-10px) rotateY(180deg);

    }

    100% {
      transform: translateY(-5px) rotateY(180deg);

    }
  }


  @keyframes rotation {
    0% {
      transform: translateY(0px) translateX(10px) rotateZ(0deg) scale(1);
    }

    10% {
      transform: translateY(20px) translateX(0px) rotateZ(36deg) scale(1);
    }

    25% {
      transform: translateY(-10px) translateX(-5px) rotateZ(90deg) scale(1);

    }

    30% {
      transform: translateY(0px) translateX(0px) rotateZ(108deg) scale(0.9);
    }

    50% {
      transform: translateY(20px) translateX(10px) rotateZ(180deg) scale(1);
    }

    60% {
      transform: translateY(-13px) translateX(0px) rotateZ(216deg) scale(1);

    }

    75% {
      transform: translateY(0px) translateX(-13px) rotateZ(270deg) scale(1.2);

    }

    90% {
      transform: translateY(5px) translateX(0px) rotateZ(324deg) scale(1);

    }

    100% {
      transform: translateY(0px) translateX(10px) rotateZ(360deg) scale(1);
    }
  }



  @keyframes rotation_paired_0 {
    0% {
      transform: translateY(0px) translateX(10px) rotateZ(0deg) scale(1);
    }

    10% {
      transform: translateY(20px) translateX(0px) rotateZ(36deg) scale(1);
    }

    25% {
      transform: translateY(-10px) translateX(-5px) rotateZ(90deg) scale(1);

    }

    30% {
      transform: translateY(0px) translateX(0px) rotateZ(108deg) scale(0.9);
    }

    50% {
      transform: translateY(20px) translateX(10px) rotateZ(180deg) scale(1);
    }

    60% {
      transform: translateY(-13px) translateX(0px) rotateZ(216deg) scale(1);
    }

    75% {
      transform: translateY(0px) translateX(-13px) rotateZ(270deg) scale(1.2);

    }

    90% {
      transform: translateY(5px) translateX(0px) rotateZ(324deg) scale(1);

    }

    100% {
      transform: translateY(0px) translateX(10px) rotateZ(360deg) scale(1);
    }
  }



  @keyframes rotation_paired_1 {
    0% {
      transform: translateY(0px) translateX(10px) rotateZ(0deg) rotateY(180deg) scale(1);
    }

    10% {
      transform: translateY(20px) translateX(0px) rotateZ(-36deg) rotateY(180deg) scale(1);
    }

    25% {
      transform: translateY(-10px) translateX(-5px) rotateZ(-90deg) rotateY(180deg) scale(1);

    }

    30% {
      transform: translateY(0px) translateX(0px) rotateZ(-108deg) rotateY(180deg) scale(0.9);
    }

    50% {
      transform: translateY(20px) translateX(10px) rotateZ(-180deg) rotateY(180deg) scale(1);
    }

    60% {
      transform: translateY(-13px) translateX(0px) rotateZ(-216deg) rotateY(180deg) scale(1);
    }

    75% {
      transform: translateY(0px) translateX(-13px) rotateZ(-270deg) rotateY(180deg) scale(1.2);

    }

    90% {
      transform: translateY(5px) translateX(0px) rotateZ(-324deg) rotateY(180deg) scale(1);

    }

    100% {
      transform: translateY(0px) translateX(10px) rotateZ(-360deg) rotateY(180deg) scale(1);
    }
  }




  @keyframes rotation_paired_2 {
    0% {
      transform: translateY(0px) translateX(10px) rotateZ(0deg) scale(1);
    }

    10% {
      transform: translateY(20px) translateX(0px) rotateZ(36deg) scale(1);
    }

    25% {
      transform: translateY(-10px) translateX(-5px) rotateZ(90deg) scale(1);

    }

    30% {
      transform: translateY(0px) translateX(0px) rotateZ(108deg) scale(0.9);
    }

    50% {
      transform: translateY(20px) translateX(10px) rotateZ(180deg) scale(1);
    }

    60% {
      transform: translateY(-13px) translateX(0px) rotateZ(216deg) scale(1);
    }

    75% {
      transform: translateY(0px) translateX(-13px) rotateZ(270deg) scale(1.2);

    }

    90% {
      transform: translateY(5px) translateX(0px) rotateZ(324deg) scale(1);

    }

    100% {
      transform: translateY(0px) translateX(10px) rotateZ(360deg) scale(1);
    }
  }



  @keyframes rotation_paired_3 {
    0% {
      transform: translateY(0px) translateX(-10px) rotateZ(0deg) rotateY(180deg) scale(1);
    }

    10% {
      transform: translateY(20px) translateX(0px) rotateZ(36deg) rotateY(180deg) scale(1);
    }

    25% {
      transform: translateY(-10px) translateX(5px) rotateZ(90deg) rotateY(180deg) scale(1);

    }

    30% {
      transform: translateY(0px) translateX(0px) rotateZ(108deg) rotateY(180deg) scale(0.9);
    }

    50% {
      transform: translateY(20px) translateX(-10px) rotateZ(180deg) rotateY(180deg) scale(1);
    }

    60% {
      transform: translateY(-13px) translateX(0px) rotateZ(216deg) rotateY(180deg) scale(1);
    }

    75% {
      transform: translateY(0px) translateX(13px) rotateZ(270deg) rotateY(180deg) scale(1.2);

    }

    90% {
      transform: translateY(5px) translateX(0px) rotateZ(324deg) rotateY(180deg) scale(1);

    }

    100% {
      transform: translateY(0px) translateX(-10px) rotateZ(360deg) rotateY(180deg) scale(1);
    }
  }




  body {
    overflow-x: hidden;
  }

  h1 {
    margin-top: 0;
  }

  .top_padded {
    padding: 30px 0;
  }

  .background {
    position: absolute;
    height: 100vh;
    overflow: hidden;
    width: 100vw;
    z-index: -1;
  }

  .bg_ipad {
    position: absolute;
    width: 300px;
    left: calc(50% + 300px);
    top: 30%;
    z-index: 100;
    animation: hardhat_1 10s infinite linear;
  }

  .bg_glasses {
    position: absolute;
    right: calc(50% + 400px);
    top: 200px;
    height: 200px;
    -webkit-animation: hover 10s infinite linear;
    animation: hover 10s infinite linear;
  }

  .bg_boot {
    position: absolute;
    right: calc(50% + 400px);
    top: 300px;
    height: 100px;
    animation: hover 10s infinite linear;

  }

  .bg_boot_2 {
    position: absolute;
    right: calc(50% + 300px);
    top: 280px;
    height: 200px;
    animation: hover 10s infinite linear;

  }

  .bg_earphones {
    position: absolute;
    right: calc(50% + 450px);
    top: 100px;
    height: 100px;
    animation: hardhat_1 10s infinite linear;

  }

  .bg_glove {
    position: absolute;
    right: calc(50% + 500px);
    top: 500px;
    height: 100px;
    animation: hover 10s infinite linear;

  }

  .bg_glove_2 {
    position: absolute;
    right: calc(50% + 400px);
    top: 430px;
    height: 200px;
    animation: hover 10s infinite linear;

  }

  .bg_hardhat {
    position: absolute;
    right: calc(50% + 550px);
    top: 350px;
    height: 100px;
    animation: hover 10s infinite linear;
  }

  @media (max-height: 700px) {
    .bg_glove_2 {
      top: 410px;
    }
    .bg_glove {
      top: 470px;
    }
    .bg_hardhat {
      top: 360px;
      left: 23px;
      width: 135px;
    }
  }
</style>